import React from "react";
import compose from "recompose/compose";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router";
import { H2 } from "theme/components/atoms/Typography/Heading";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import ProductListSlider, {
  withNumberOfProductsPerSlide,
} from "theme/modules/ProductList/ProductListSlider";
import Section from "theme/components/organisms/Section";

const RelatedProducts = ({
  products,
  numberOfProductsPerSlide,
  imageSizes,
  prioritizeTop = 0,
}) => {
  const location = useLocation();
  return (
    <Section
      title={
        <H2>
          <FormattedMessage
            id="modules.ProductList.RelatedProducts.tagline"
            defaultMessage="Related products"
          />
        </H2>
      }
    >
      <ProductListSlider
        length={products.length}
        numberOfProductsPerSlide={numberOfProductsPerSlide}
        products={products}
        location={location}
        productItemProp="isRelatedTo"
        imageSizes={imageSizes}
        prioritizeTop={prioritizeTop}
      />
    </Section>
  );
};

export default compose(
  withHideOnErrorBoundary,
  withNumberOfProductsPerSlide()
)(RelatedProducts);
